import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              精彩推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              编辑精选 · 每日更新热门电影与剧集
            </p>
          </div>
          <a
            href="#cards"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('cards')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="text-sm text-primary-600 font-medium whitespace-nowrap cursor-pointer hover:text-primary-700 transition-colors"
          >
            查看全部 <i className="ri-arrow-right-line ml-1 text-xs"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-200 mb-3">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 rounded-md bg-accent-500 text-background-50 text-[11px] font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <div className="flex items-center gap-2 text-background-50/90 text-xs">
                    <span>{item.duration}</span>
                    <span className="w-1 h-1 rounded-full bg-background-50/60"></span>
                    <span className="font-bold text-primary-300">{item.heat}</span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{item.year}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}